<template>
  <v-layout wrap pb-12>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex>
      <v-card>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-layout
              :justify-start="$vuetify.breakpoint.name !== 'xs' ? true : false"
              :justify-center="$vuetify.breakpoint.name == 'xs' ? true : false"
              wrap
              pt-6
            >
              <v-layout justify-center wrap>
                <v-flex xs3 sm3 md3 pl-5 text-center>
                  <v-img
                    width="30px"
                    src="./../../assets/images/subject.svg"
                  ></v-img>
                </v-flex>
                <v-flex xs9 sm9 md9 text-left>
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >View Subject</span
                  >
                </v-flex>
              </v-layout>
              <v-flex xs6 sm6 md9>
                <router-link :to="'/addSubject'" style="text-decoration: none">
                  <span
                    style="
                      color: #797979;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >Add Subject</span
                  >
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md10 pa-2>
                <v-select
                  dense
                  style="font-family: nunitosansregular"
                  :items="subjectArray"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Subject"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md2 pa-2>
                <v-btn
                  dark
                  style="font-family: nunitosansregular"
                  color="#9B8DFD"
                  >SEARCH</v-btn
                >
              </v-flex>
              <v-layout justify-center wrap v-if="subject.length > 0">
                <v-flex pb-2 pa-2 v-for="(item, i) in subject" :key="i" xs12>
                  <span style="font-family: nunitosanssemibold">
                    Class {{ item.standard.standardName }} ( A - D )</span
                  >
                  <v-flex pt-2>
                    <!-- <v-chip
                      color="#747474"
                      outlined
                      block
                      class="ma-1"
                      v-for="list in item.subjects"
                      :key="list.index"
                      style="margin-right: 1%; text-transform: uppercase"
                    > -->
                    <v-layout wrap>
                      <v-flex
                        xs3
                        pa-2
                        v-for="list in item.subjects"
                        :key="list.index"
                      >
                        <v-card>
                          <v-card-text>
                            <v-layout justify-center wrap>
                              <v-flex xs2 pt-1 pr-2 v-if="list.color">
                                <v-card
                                  rounded="xl"
                                  outlined
                                  :color="list.color"
                                  width="15"
                                  height="15"
                                >
                                </v-card>
                              </v-flex>
                              <v-flex xs7>
                                <span
                                  style="
                                    font-family: nunitosansregular;
                                    font-size: 12px;
                                    color: black;
                                  "
                                >
                                  {{ list.subjectName }}</span
                                >
                              </v-flex>
                              <v-flex xs2>
                                <v-icon size="15" @click="editItem(list, item)"
                                  >mdi-file-edit-outline</v-icon
                                >
                              </v-flex>
                              <v-flex xs1>
                                <v-dialog
                                  v-model="list.delete"
                                  max-width="600px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon size="15" v-on="on" v-bind="attrs"
                                      >mdi-close</v-icon
                                    >
                                  </template>
                                  <v-card>
                                    <v-card-title
                                      style="font-family: nunitosansregular"
                                    >
                                      Are you sure you want to delete this
                                      subject?
                                    </v-card-title>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="list.delete = false"
                                        >Cancel</v-btn
                                      >
                                      <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="deleteItem(list, item)"
                                        >OK</v-btn
                                      >
                                      <v-spacer></v-spacer>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <!-- </v-chip> -->
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-layout v-else justify-center wrap py-8>
                <v-flex xs12 text-center>
                  <span
                    style="
                      font-family: nunitosansregular;
                      color: #000000;
                      font-size: 14px;
                    "
                    >Oops !! No data found..</span
                  >
                </v-flex>
              </v-layout>
              <v-dialog v-model="editdialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Edit Subject</span>
                  </v-card-title>
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <v-flex xs12 sm6 md6 pa-2>
                        <v-select
                          v-model="editingitem.standard"
                          dense
                          readonly
                          style="font-family: nunitosansregular"
                          :items="classArray"
                          item-text="standardName"
                          item-value="_id"
                          outlined
                          label="Class"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6 pa-2>
                        <v-text-field
                          readonly
                          style="font-family: nunitosansregular"
                          label=" Subject Name"
                          outlined
                          dense
                          v-model="editingitem.subjectName"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 pa-2>
                        <!-- <v-color-picker
                          dot-size="25"
                          hide-mode-switch
                          mode="hexa"
                          swatches-max-height="200"
                          v-model="editingitem.color"
                        ></v-color-picker> -->
                        <v-color-picker
                          mode="hexa"
                          v-model="color"
                        ></v-color-picker>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-layout justify-center wrap>
                      <v-flex xs6 sm4 px-2>
                        <v-btn
                          block
                          tile
                          color="#757575"
                          outlined
                          :ripple="false"
                          depressed
                          @click="editdialog = false"
                          >Cancel</v-btn
                        >
                      </v-flex>
                      <v-flex xs6 sm4 px-2>
                        <v-btn
                          tile
                          block
                          dark
                          color="red"
                          depressed
                          class="text-capitalize"
                          :ripple="false"
                          @click="edit()"
                          >save</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-card-text>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: "",
      tot: [],
      classArray: [],
      subject: [],
      subjectArray: [],
      editdialog: false,
      editingitem: {},
      id: null,
      subjectName: "",
      types: ["hex"],
      type: "hex",
      hex: "#FF00FF",
    };
  },
  mounted() {
    this.getData();
    this.getSubject();
    this.getStandard();
  },
  computed: {
    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
    showColor() {
      if (typeof this.color === "string") return this.color;

      return JSON.stringify(
        Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2));
          return color;
        }, {}),
        null,
        2
      );
    },
  },
  methods: {
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.classArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubject() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.classArray = response.data.data;
          var temp = [
            {
              name: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].name = temp[i].subjectName;
            temp[i].value = temp[i]._id;
          }
          this.subjectArray = temp;
          this.subjectArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/subject/getlistgrouped",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subject = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r, i) {
      var data = {};
      data["id"] = i._id;
      data["subject"] = r._id;
      axios({
        url: "/subject/standard/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/subject/edit",
        data: {
          subject: this.subjectName,
          color: this.color.hex,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = "Update Exam Successully";
            this.getData();
            this.snackbar = true;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editItem(list, item) {
      this.editingitem.standard = item.standard;
      this.editingitem.subjectName = list.subjectName;
      this.editingitem.color = list.color;
      this.color = list.color;
      this.id = item._id;
      this.subjectName = list._id;
      this.editdialog = true;
    },
  },
};
</script>
<style scoped>
#a :hover {
  background-color: #9385ef;
}
#b:hover {
  color: black;

  transition: 0.5s;
}
#b {
  color: gray;
}
.dottedline {
  border: none;
  border-top: 1px dashed rgb(208, 208, 208);
  color: #8f8f8f;
  /* text-align: center; */
  background-color: #8f8f8f;
  height: 1px;
  width: 100%;
}
</style>